import styled from "styled-components";

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderButtons = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`;

export const Title = styled.h2`
  display: flex;
  gap: 1rem;
`;

export const RowButtons = styled.span`
  display: flex;
  justify-content: center;
  gap: 1rem;
`;

export const TableHeader = styled.div`
  display: flex;
  gap: 1rem;
  font-weight: 600;
  text-align: center;

  & > * {
    flex: 1;
  }
`;

export const TableBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  text-align: center;
  overflow-y: auto;
  max-height: calc(100vh - 10rem);

  & > * {
    display: flex;
    align-items: center;
    gap: 1rem;

    & > * {
      flex: 1;
    }
  }
`;
